import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router";
import { configure } from "mobx";

import { APIOptions, PrimeReactProvider } from "primereact/api";

import { GlobalErrorBoundary } from "./app/components/Core/ErrorBoundary/GlobalErrorBoundary.tsx";
import { StoreProvider } from "./app/components/Core/StoreProvider/StoreProvider.tsx";
import { router } from "./app/components/Routes/Routes.tsx";
import { SharedDialogProvider } from "./app/components/Shared/Components/Dialogs/index.ts";
import { AuthProvider } from "./auth/AuthProvider.tsx";
import { initializeAppInsights } from "./utils/appInsights.ts";

import "./app/layout/sass/main.scss";

configure({ isolateGlobalState: true });
initializeAppInsights();

const rootElement = document.getElementById("root");
const reactRoot = ReactDOM.createRoot(rootElement as HTMLElement);

const primeReactProviderValue: Partial<APIOptions> = {
  appendTo: document.body,
  ripple: true,
  unstyled: false,
};

reactRoot.render(
  <StrictMode>
    <GlobalErrorBoundary>
      <AuthProvider>
        <PrimeReactProvider value={primeReactProviderValue}>
          <StoreProvider>
            <SharedDialogProvider>
              <RouterProvider router={router} />
            </SharedDialogProvider>
          </StoreProvider>
        </PrimeReactProvider>
      </AuthProvider>
    </GlobalErrorBoundary>
  </StrictMode>,
);
